import { render, staticRenderFns } from "./VaultFolders.vue?vue&type=template&id=c8d4009e&scoped=true&"
import script from "./VaultFolders.vue?vue&type=script&lang=js&"
export * from "./VaultFolders.vue?vue&type=script&lang=js&"
import style0 from "./VaultFolders.vue?vue&type=style&index=0&id=c8d4009e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d4009e",
  null
  
)

export default component.exports